/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AggregationMetadataLookupDTO } from "../models/aggregationMetadataLookupDTO";

import type { Application } from "../models/application";

import type { ExcelFormulaHits } from "../models/excelFormulaHits";

import type { FindExcelFormulaSuggestionsParams } from "../models/findExcelFormulaSuggestionsParams";

import type { FindNodeBuilderResourcesRequest } from "../models/findNodeBuilderResourcesRequest";

import type { FindNodesWithConnectionsParams } from "../models/findNodesWithConnectionsParams";

import type { FindResourcesForNodeParams } from "../models/findResourcesForNodeParams";

import type { GetCollectSlotSchemaBody } from "../models/getCollectSlotSchemaBody";

import type { GetNodesParams } from "../models/getNodesParams";

import type { GetWebhookTriggerUrlParams } from "../models/getWebhookTriggerUrlParams";

import type { GetWebhookUrlParams } from "../models/getWebhookUrlParams";

import type { LookupEnvVariablesSchemaParams } from "../models/lookupEnvVariablesSchemaParams";

import type { LookupNodesOutputSchemaBody } from "../models/lookupNodesOutputSchemaBody";

import type { LookupNodesOutputSchemaWithErrorsBody } from "../models/lookupNodesOutputSchemaWithErrorsBody";

import type { NodeAutoMapRequest } from "../models/nodeAutoMapRequest";

import type { NodeAutoMapResponse } from "../models/nodeAutoMapResponse";

import type { NodeBuilder } from "../models/nodeBuilder";

import type { NodeBuilderHits } from "../models/nodeBuilderHits";

import type { NodeBuilderMap } from "../models/nodeBuilderMap";

import type { NodeBuilderResource } from "../models/nodeBuilderResource";

import type { NodeBuilderResourceHits } from "../models/nodeBuilderResourceHits";

import type { NodeBuilderResourceListMap } from "../models/nodeBuilderResourceListMap";

import type { NodeBuilderResourceMap } from "../models/nodeBuilderResourceMap";

import type { NodeSchemaLookupDTO } from "../models/nodeSchemaLookupDTO";

import type { NodeSchemaWithErrorsResponse } from "../models/nodeSchemaWithErrorsResponse";

import type { NodeSearchQuery } from "../models/nodeSearchQuery";

import type { NodesAndResourcesSearchResponse } from "../models/nodesAndResourcesSearchResponse";

import type { Schema } from "../models/schema";

import type { SchemaLookupDTO } from "../models/schemaLookupDTO";

import type { SchemaMap } from "../models/schemaMap";

import type { StringObjectMap2 } from "../models/stringObjectMap2";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get Collect Slot Schema
 */
export const getCollectSlotSchema = (
  getCollectSlotSchemaBody: GetCollectSlotSchemaBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/collect-slot-schema`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getCollectSlotSchemaBody,
      signal,
    },
    options,
  );
};

export const getGetCollectSlotSchemaQueryKey = (
  getCollectSlotSchemaBody?: GetCollectSlotSchemaBody,
) => {
  return [
    `/api/workflow-builder/collect-slot-schema`,
    getCollectSlotSchemaBody,
  ] as const;
};

export const getGetCollectSlotSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectSlotSchema>>,
  TError = ErrorType<unknown>,
>(
  getCollectSlotSchemaBody: GetCollectSlotSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectSlotSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectSlotSchemaQueryKey(getCollectSlotSchemaBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectSlotSchema>>
  > = ({ signal, meta }) =>
    getCollectSlotSchema(
      getCollectSlotSchemaBody,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectSlotSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCollectSlotSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectSlotSchema>>
>;
export type GetCollectSlotSchemaQueryError = ErrorType<unknown>;

export function useGetCollectSlotSchema<
  TData = Awaited<ReturnType<typeof getCollectSlotSchema>>,
  TError = ErrorType<unknown>,
>(
  getCollectSlotSchemaBody: GetCollectSlotSchemaBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectSlotSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectSlotSchema>>,
          TError,
          Awaited<ReturnType<typeof getCollectSlotSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollectSlotSchema<
  TData = Awaited<ReturnType<typeof getCollectSlotSchema>>,
  TError = ErrorType<unknown>,
>(
  getCollectSlotSchemaBody: GetCollectSlotSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectSlotSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectSlotSchema>>,
          TError,
          Awaited<ReturnType<typeof getCollectSlotSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollectSlotSchema<
  TData = Awaited<ReturnType<typeof getCollectSlotSchema>>,
  TError = ErrorType<unknown>,
>(
  getCollectSlotSchemaBody: GetCollectSlotSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectSlotSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Collect Slot Schema
 */

export function useGetCollectSlotSchema<
  TData = Awaited<ReturnType<typeof getCollectSlotSchema>>,
  TError = ErrorType<unknown>,
>(
  getCollectSlotSchemaBody: GetCollectSlotSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectSlotSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCollectSlotSchemaQueryOptions(
    getCollectSlotSchemaBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Collect Slot Schema
 */
export const prefetchGetCollectSlotSchema = async <
  TData = Awaited<ReturnType<typeof getCollectSlotSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  getCollectSlotSchemaBody: GetCollectSlotSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectSlotSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetCollectSlotSchemaQueryOptions(
    getCollectSlotSchemaBody,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Environment Variables
 */
export const fetchEnvVariables = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    { url: `/api/workflow-builder/env-variables`, method: "GET", signal },
    options,
  );
};

export const getFetchEnvVariablesQueryKey = () => {
  return [`/api/workflow-builder/env-variables`] as const;
};

export const getFetchEnvVariablesQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchEnvVariables>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchEnvVariables>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchEnvVariablesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchEnvVariables>>
  > = ({ signal, meta }) =>
    fetchEnvVariables({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchEnvVariables>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchEnvVariablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchEnvVariables>>
>;
export type FetchEnvVariablesQueryError = ErrorType<unknown>;

export function useFetchEnvVariables<
  TData = Awaited<ReturnType<typeof fetchEnvVariables>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEnvVariables>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEnvVariables>>,
          TError,
          Awaited<ReturnType<typeof fetchEnvVariables>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEnvVariables<
  TData = Awaited<ReturnType<typeof fetchEnvVariables>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEnvVariables>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEnvVariables>>,
          TError,
          Awaited<ReturnType<typeof fetchEnvVariables>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEnvVariables<
  TData = Awaited<ReturnType<typeof fetchEnvVariables>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEnvVariables>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Environment Variables
 */

export function useFetchEnvVariables<
  TData = Awaited<ReturnType<typeof fetchEnvVariables>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEnvVariables>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchEnvVariablesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Environment Variables
 */
export const prefetchFetchEnvVariables = async <
  TData = Awaited<ReturnType<typeof fetchEnvVariables>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEnvVariables>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFetchEnvVariablesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Excel Formula Suggestions
 */
export const findExcelFormulaSuggestions = (
  params?: FindExcelFormulaSuggestionsParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<ExcelFormulaHits>(
    {
      url: `/api/workflow-builder/excel-formula/suggestions`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getFindExcelFormulaSuggestionsQueryKey = (
  params?: FindExcelFormulaSuggestionsParams,
) => {
  return [
    `/api/workflow-builder/excel-formula/suggestions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindExcelFormulaSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
  TError = ErrorType<unknown>,
>(
  params?: FindExcelFormulaSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindExcelFormulaSuggestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findExcelFormulaSuggestions>>
  > = ({ signal, meta }) =>
    findExcelFormulaSuggestions(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindExcelFormulaSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findExcelFormulaSuggestions>>
>;
export type FindExcelFormulaSuggestionsQueryError = ErrorType<unknown>;

export function useFindExcelFormulaSuggestions<
  TData = Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | FindExcelFormulaSuggestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
          TError,
          Awaited<ReturnType<typeof findExcelFormulaSuggestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindExcelFormulaSuggestions<
  TData = Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
  TError = ErrorType<unknown>,
>(
  params?: FindExcelFormulaSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
          TError,
          Awaited<ReturnType<typeof findExcelFormulaSuggestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindExcelFormulaSuggestions<
  TData = Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
  TError = ErrorType<unknown>,
>(
  params?: FindExcelFormulaSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Excel Formula Suggestions
 */

export function useFindExcelFormulaSuggestions<
  TData = Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
  TError = ErrorType<unknown>,
>(
  params?: FindExcelFormulaSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindExcelFormulaSuggestionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Excel Formula Suggestions
 */
export const prefetchFindExcelFormulaSuggestions = async <
  TData = Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: FindExcelFormulaSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findExcelFormulaSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindExcelFormulaSuggestionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Nodes With Connections
 */
export const findNodesWithConnections = (
  params?: FindNodesWithConnectionsParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilder[]>(
    {
      url: `/api/workflow-builder/find-nodes-with-connections`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getFindNodesWithConnectionsQueryKey = (
  params?: FindNodesWithConnectionsParams,
) => {
  return [
    `/api/workflow-builder/find-nodes-with-connections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindNodesWithConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof findNodesWithConnections>>,
  TError = ErrorType<unknown>,
>(
  params?: FindNodesWithConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNodesWithConnections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindNodesWithConnectionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findNodesWithConnections>>
  > = ({ signal, meta }) =>
    findNodesWithConnections(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findNodesWithConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindNodesWithConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findNodesWithConnections>>
>;
export type FindNodesWithConnectionsQueryError = ErrorType<unknown>;

export function useFindNodesWithConnections<
  TData = Awaited<ReturnType<typeof findNodesWithConnections>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | FindNodesWithConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNodesWithConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNodesWithConnections>>,
          TError,
          Awaited<ReturnType<typeof findNodesWithConnections>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNodesWithConnections<
  TData = Awaited<ReturnType<typeof findNodesWithConnections>>,
  TError = ErrorType<unknown>,
>(
  params?: FindNodesWithConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNodesWithConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNodesWithConnections>>,
          TError,
          Awaited<ReturnType<typeof findNodesWithConnections>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNodesWithConnections<
  TData = Awaited<ReturnType<typeof findNodesWithConnections>>,
  TError = ErrorType<unknown>,
>(
  params?: FindNodesWithConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNodesWithConnections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Nodes With Connections
 */

export function useFindNodesWithConnections<
  TData = Awaited<ReturnType<typeof findNodesWithConnections>>,
  TError = ErrorType<unknown>,
>(
  params?: FindNodesWithConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNodesWithConnections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindNodesWithConnectionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Nodes With Connections
 */
export const prefetchFindNodesWithConnections = async <
  TData = Awaited<ReturnType<typeof findNodesWithConnections>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: FindNodesWithConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNodesWithConnections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindNodesWithConnectionsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Listen For Webhook Request Schema
 */
export const listenForWebhookRequestSchema = (
  workflowId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<StringObjectMap2>(
    {
      url: `/api/workflow-builder/listen-for-webhook-request-schema/${encodeURIComponent(String(workflowId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getListenForWebhookRequestSchemaQueryKey = (
  workflowId?: string,
) => {
  return [
    `/api/workflow-builder/listen-for-webhook-request-schema/${workflowId}`,
  ] as const;
};

export const getListenForWebhookRequestSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListenForWebhookRequestSchemaQueryKey(workflowId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listenForWebhookRequestSchema>>
  > = ({ signal, meta }) =>
    listenForWebhookRequestSchema(
      workflowId,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListenForWebhookRequestSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof listenForWebhookRequestSchema>>
>;
export type ListenForWebhookRequestSchemaQueryError = ErrorType<unknown>;

export function useListenForWebhookRequestSchema<
  TData = Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
          TError,
          Awaited<ReturnType<typeof listenForWebhookRequestSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListenForWebhookRequestSchema<
  TData = Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
          TError,
          Awaited<ReturnType<typeof listenForWebhookRequestSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListenForWebhookRequestSchema<
  TData = Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Listen For Webhook Request Schema
 */

export function useListenForWebhookRequestSchema<
  TData = Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListenForWebhookRequestSchemaQueryOptions(
    workflowId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Listen For Webhook Request Schema
 */
export const prefetchListenForWebhookRequestSchema = async <
  TData = Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listenForWebhookRequestSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListenForWebhookRequestSchemaQueryOptions(
    workflowId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Alert Variables Schema
 */
export const lookupAlertVariablesSchema = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/lookup/alert-variables-schema`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupAlertVariablesSchemaQueryKey = () => {
  return [`/api/workflow-builder/lookup/alert-variables-schema`] as const;
};

export const getLookupAlertVariablesSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupAlertVariablesSchemaQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupAlertVariablesSchema>>
  > = ({ signal, meta }) =>
    lookupAlertVariablesSchema({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupAlertVariablesSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupAlertVariablesSchema>>
>;
export type LookupAlertVariablesSchemaQueryError = ErrorType<unknown>;

export function useLookupAlertVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupAlertVariablesSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupAlertVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupAlertVariablesSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupAlertVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Alert Variables Schema
 */

export function useLookupAlertVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupAlertVariablesSchemaQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Alert Variables Schema
 */
export const prefetchLookupAlertVariablesSchema = async <
  TData = Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupAlertVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupAlertVariablesSchemaQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Applications
 */
export const lookupApplications = (
  workflowId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Application[]>(
    {
      url: `/api/workflow-builder/lookup/applications/${encodeURIComponent(String(workflowId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupApplicationsQueryKey = (workflowId?: string) => {
  return [`/api/workflow-builder/lookup/applications/${workflowId}`] as const;
};

export const getLookupApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupApplications>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupApplications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupApplicationsQueryKey(workflowId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupApplications>>
  > = ({ signal, meta }) =>
    lookupApplications(workflowId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupApplications>>
>;
export type LookupApplicationsQueryError = ErrorType<unknown>;

export function useLookupApplications<
  TData = Awaited<ReturnType<typeof lookupApplications>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupApplications>>,
          TError,
          Awaited<ReturnType<typeof lookupApplications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupApplications<
  TData = Awaited<ReturnType<typeof lookupApplications>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupApplications>>,
          TError,
          Awaited<ReturnType<typeof lookupApplications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupApplications<
  TData = Awaited<ReturnType<typeof lookupApplications>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupApplications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Applications
 */

export function useLookupApplications<
  TData = Awaited<ReturnType<typeof lookupApplications>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupApplications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupApplicationsQueryOptions(workflowId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Applications
 */
export const prefetchLookupApplications = async <
  TData = Awaited<ReturnType<typeof lookupApplications>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupApplications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupApplicationsQueryOptions(workflowId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Env Schema
 */
export const lookupEnvVariablesSchema = (
  params?: LookupEnvVariablesSchemaParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/lookup/env-variables-schema`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getLookupEnvVariablesSchemaQueryKey = (
  params?: LookupEnvVariablesSchemaParams,
) => {
  return [
    `/api/workflow-builder/lookup/env-variables-schema`,
    ...(params ? [params] : []),
  ] as const;
};

export const getLookupEnvVariablesSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  params?: LookupEnvVariablesSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupEnvVariablesSchemaQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupEnvVariablesSchema>>
  > = ({ signal, meta }) =>
    lookupEnvVariablesSchema(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupEnvVariablesSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupEnvVariablesSchema>>
>;
export type LookupEnvVariablesSchemaQueryError = ErrorType<unknown>;

export function useLookupEnvVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | LookupEnvVariablesSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupEnvVariablesSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupEnvVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  params?: LookupEnvVariablesSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupEnvVariablesSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupEnvVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  params?: LookupEnvVariablesSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Env Schema
 */

export function useLookupEnvVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  params?: LookupEnvVariablesSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupEnvVariablesSchemaQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Env Schema
 */
export const prefetchLookupEnvVariablesSchema = async <
  TData = Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: LookupEnvVariablesSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupEnvVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupEnvVariablesSchemaQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Error Schema
 */
export const lookupErrorSchema = (
  schemaLookupDTO: SchemaLookupDTO,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<SchemaMap>(
    {
      url: `/api/workflow-builder/lookup/error-schema`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: schemaLookupDTO,
      signal,
    },
    options,
  );
};

export const getLookupErrorSchemaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupErrorSchema>>,
    TError,
    { data: SchemaLookupDTO },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupErrorSchema>>,
  TError,
  { data: SchemaLookupDTO },
  TContext
> => {
  const mutationKey = ["lookupErrorSchema"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupErrorSchema>>,
    { data: SchemaLookupDTO }
  > = (props, context) => {
    const { data } = props ?? {};

    return lookupErrorSchema(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupErrorSchemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupErrorSchema>>
>;
export type LookupErrorSchemaMutationBody = SchemaLookupDTO;
export type LookupErrorSchemaMutationError = ErrorType<unknown>;

/**
 * @summary Lookup Error Schema
 */
export const useLookupErrorSchema = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lookupErrorSchema>>,
      TError,
      { data: SchemaLookupDTO },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof lookupErrorSchema>>,
  TError,
  { data: SchemaLookupDTO },
  TContext
> => {
  const mutationOptions = getLookupErrorSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Lookup Error Schema
 */
export const lookupErrorSchemaByWorkflowId = (
  workflowId: string,
  lookupErrorSchemaByWorkflowIdBody: string[],
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<SchemaMap>(
    {
      url: `/api/workflow-builder/lookup/error-schema/${encodeURIComponent(String(workflowId))}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupErrorSchemaByWorkflowIdBody,
      signal,
    },
    options,
  );
};

export const getLookupErrorSchemaByWorkflowIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupErrorSchemaByWorkflowId>>,
    TError,
    { workflowId: string; data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupErrorSchemaByWorkflowId>>,
  TError,
  { workflowId: string; data: string[] },
  TContext
> => {
  const mutationKey = ["lookupErrorSchemaByWorkflowId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupErrorSchemaByWorkflowId>>,
    { workflowId: string; data: string[] }
  > = (props, context) => {
    const { workflowId, data } = props ?? {};

    return lookupErrorSchemaByWorkflowId(workflowId, data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupErrorSchemaByWorkflowIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupErrorSchemaByWorkflowId>>
>;
export type LookupErrorSchemaByWorkflowIdMutationBody = string[];
export type LookupErrorSchemaByWorkflowIdMutationError = ErrorType<unknown>;

/**
 * @summary Lookup Error Schema
 */
export const useLookupErrorSchemaByWorkflowId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lookupErrorSchemaByWorkflowId>>,
      TError,
      { workflowId: string; data: string[] },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof lookupErrorSchemaByWorkflowId>>,
  TError,
  { workflowId: string; data: string[] },
  TContext
> => {
  const mutationOptions =
    getLookupErrorSchemaByWorkflowIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Lookup Input Schema
 */
export const lookupInputSchema = (
  schemaLookupDTO: SchemaLookupDTO,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<SchemaMap>(
    {
      url: `/api/workflow-builder/lookup/input-schema`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: schemaLookupDTO,
      signal,
    },
    options,
  );
};

export const getLookupInputSchemaQueryKey = (
  schemaLookupDTO?: SchemaLookupDTO,
) => {
  return [
    `/api/workflow-builder/lookup/input-schema`,
    schemaLookupDTO,
  ] as const;
};

export const getLookupInputSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupInputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupInputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupInputSchemaQueryKey(schemaLookupDTO);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupInputSchema>>
  > = ({ signal, meta }) =>
    lookupInputSchema(schemaLookupDTO, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupInputSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupInputSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupInputSchema>>
>;
export type LookupInputSchemaQueryError = ErrorType<unknown>;

export function useLookupInputSchema<
  TData = Awaited<ReturnType<typeof lookupInputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupInputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupInputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupInputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupInputSchema<
  TData = Awaited<ReturnType<typeof lookupInputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupInputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupInputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupInputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupInputSchema<
  TData = Awaited<ReturnType<typeof lookupInputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupInputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Input Schema
 */

export function useLookupInputSchema<
  TData = Awaited<ReturnType<typeof lookupInputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupInputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupInputSchemaQueryOptions(
    schemaLookupDTO,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Input Schema
 */
export const prefetchLookupInputSchema = async <
  TData = Awaited<ReturnType<typeof lookupInputSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupInputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupInputSchemaQueryOptions(
    schemaLookupDTO,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Node Aggregation Metadata
 */
export const lookupNodeAggregationMetadata = (
  aggregationMetadataLookupDTO: AggregationMetadataLookupDTO,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/workflow-builder/lookup/node/aggregation-metadata`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aggregationMetadataLookupDTO,
      signal,
    },
    options,
  );
};

export const getLookupNodeAggregationMetadataQueryKey = (
  aggregationMetadataLookupDTO?: AggregationMetadataLookupDTO,
) => {
  return [
    `/api/workflow-builder/lookup/node/aggregation-metadata`,
    aggregationMetadataLookupDTO,
  ] as const;
};

export const getLookupNodeAggregationMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataLookupDTO: AggregationMetadataLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLookupNodeAggregationMetadataQueryKey(aggregationMetadataLookupDTO);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>
  > = ({ signal, meta }) =>
    lookupNodeAggregationMetadata(
      aggregationMetadataLookupDTO,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupNodeAggregationMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>
>;
export type LookupNodeAggregationMetadataQueryError = ErrorType<unknown>;

export function useLookupNodeAggregationMetadata<
  TData = Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataLookupDTO: AggregationMetadataLookupDTO,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
          TError,
          Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupNodeAggregationMetadata<
  TData = Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataLookupDTO: AggregationMetadataLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
          TError,
          Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupNodeAggregationMetadata<
  TData = Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataLookupDTO: AggregationMetadataLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Node Aggregation Metadata
 */

export function useLookupNodeAggregationMetadata<
  TData = Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataLookupDTO: AggregationMetadataLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupNodeAggregationMetadataQueryOptions(
    aggregationMetadataLookupDTO,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Node Aggregation Metadata
 */
export const prefetchLookupNodeAggregationMetadata = async <
  TData = Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  aggregationMetadataLookupDTO: AggregationMetadataLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeAggregationMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupNodeAggregationMetadataQueryOptions(
    aggregationMetadataLookupDTO,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Output Schema
 */
export const lookupNodeOutputSchema = (
  nodeSchemaLookupDTO: NodeSchemaLookupDTO,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/lookup/node/output-schema`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nodeSchemaLookupDTO,
      signal,
    },
    options,
  );
};

export const getLookupNodeOutputSchemaQueryKey = (
  nodeSchemaLookupDTO?: NodeSchemaLookupDTO,
) => {
  return [
    `/api/workflow-builder/lookup/node/output-schema`,
    nodeSchemaLookupDTO,
  ] as const;
};

export const getLookupNodeOutputSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  nodeSchemaLookupDTO: NodeSchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLookupNodeOutputSchemaQueryKey(nodeSchemaLookupDTO);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupNodeOutputSchema>>
  > = ({ signal, meta }) =>
    lookupNodeOutputSchema(
      nodeSchemaLookupDTO,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupNodeOutputSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupNodeOutputSchema>>
>;
export type LookupNodeOutputSchemaQueryError = ErrorType<unknown>;

export function useLookupNodeOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  nodeSchemaLookupDTO: NodeSchemaLookupDTO,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupNodeOutputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupNodeOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  nodeSchemaLookupDTO: NodeSchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupNodeOutputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupNodeOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  nodeSchemaLookupDTO: NodeSchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Output Schema
 */

export function useLookupNodeOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  nodeSchemaLookupDTO: NodeSchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupNodeOutputSchemaQueryOptions(
    nodeSchemaLookupDTO,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Output Schema
 */
export const prefetchLookupNodeOutputSchema = async <
  TData = Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  nodeSchemaLookupDTO: NodeSchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodeOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupNodeOutputSchemaQueryOptions(
    nodeSchemaLookupDTO,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Nodes
 */
export const lookupNodes = (
  lookupNodesBody: string[],
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilderMap>(
    {
      url: `/api/workflow-builder/lookup/nodes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupNodesBody,
      signal,
    },
    options,
  );
};

export const getLookupNodesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupNodes>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupNodes>>,
  TError,
  { data: string[] },
  TContext
> => {
  const mutationKey = ["lookupNodes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupNodes>>,
    { data: string[] }
  > = (props, context) => {
    const { data } = props ?? {};

    return lookupNodes(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupNodesMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupNodes>>
>;
export type LookupNodesMutationBody = string[];
export type LookupNodesMutationError = ErrorType<unknown>;

/**
 * @summary Lookup Nodes
 */
export const useLookupNodes = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lookupNodes>>,
      TError,
      { data: string[] },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof lookupNodes>>,
  TError,
  { data: string[] },
  TContext
> => {
  const mutationOptions = getLookupNodesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Lookup Output Schema
 */
export const lookupNodesOutputSchema = (
  lookupNodesOutputSchemaBody: LookupNodesOutputSchemaBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<SchemaMap>(
    {
      url: `/api/workflow-builder/lookup/nodes/output-schema`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupNodesOutputSchemaBody,
      signal,
    },
    options,
  );
};

export const getLookupNodesOutputSchemaQueryKey = (
  lookupNodesOutputSchemaBody?: LookupNodesOutputSchemaBody,
) => {
  return [
    `/api/workflow-builder/lookup/nodes/output-schema`,
    lookupNodesOutputSchemaBody,
  ] as const;
};

export const getLookupNodesOutputSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  lookupNodesOutputSchemaBody: LookupNodesOutputSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLookupNodesOutputSchemaQueryKey(lookupNodesOutputSchemaBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupNodesOutputSchema>>
  > = ({ signal, meta }) =>
    lookupNodesOutputSchema(
      lookupNodesOutputSchemaBody,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupNodesOutputSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupNodesOutputSchema>>
>;
export type LookupNodesOutputSchemaQueryError = ErrorType<unknown>;

export function useLookupNodesOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  lookupNodesOutputSchemaBody: LookupNodesOutputSchemaBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupNodesOutputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupNodesOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  lookupNodesOutputSchemaBody: LookupNodesOutputSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupNodesOutputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupNodesOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  lookupNodesOutputSchemaBody: LookupNodesOutputSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Output Schema
 */

export function useLookupNodesOutputSchema<
  TData = Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  lookupNodesOutputSchemaBody: LookupNodesOutputSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupNodesOutputSchemaQueryOptions(
    lookupNodesOutputSchemaBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Output Schema
 */
export const prefetchLookupNodesOutputSchema = async <
  TData = Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  lookupNodesOutputSchemaBody: LookupNodesOutputSchemaBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupNodesOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupNodesOutputSchemaQueryOptions(
    lookupNodesOutputSchemaBody,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Output Schema With Errors
 */
export const lookupNodesOutputSchemaWithErrors = (
  lookupNodesOutputSchemaWithErrorsBody: LookupNodesOutputSchemaWithErrorsBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeSchemaWithErrorsResponse>(
    {
      url: `/api/workflow-builder/lookup/nodes/output-schema/with-errors`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupNodesOutputSchemaWithErrorsBody,
      signal,
    },
    options,
  );
};

export const getLookupNodesOutputSchemaWithErrorsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupNodesOutputSchemaWithErrors>>,
    TError,
    { data: LookupNodesOutputSchemaWithErrorsBody },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupNodesOutputSchemaWithErrors>>,
  TError,
  { data: LookupNodesOutputSchemaWithErrorsBody },
  TContext
> => {
  const mutationKey = ["lookupNodesOutputSchemaWithErrors"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupNodesOutputSchemaWithErrors>>,
    { data: LookupNodesOutputSchemaWithErrorsBody }
  > = (props, context) => {
    const { data } = props ?? {};

    return lookupNodesOutputSchemaWithErrors(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupNodesOutputSchemaWithErrorsMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupNodesOutputSchemaWithErrors>>
>;
export type LookupNodesOutputSchemaWithErrorsMutationBody =
  LookupNodesOutputSchemaWithErrorsBody;
export type LookupNodesOutputSchemaWithErrorsMutationError = ErrorType<unknown>;

/**
 * @summary Lookup Output Schema With Errors
 */
export const useLookupNodesOutputSchemaWithErrors = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lookupNodesOutputSchemaWithErrors>>,
      TError,
      { data: LookupNodesOutputSchemaWithErrorsBody },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof lookupNodesOutputSchemaWithErrors>>,
  TError,
  { data: LookupNodesOutputSchemaWithErrorsBody },
  TContext
> => {
  const mutationOptions =
    getLookupNodesOutputSchemaWithErrorsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Lookup Output Schema
 */
export const lookupOutputSchema = (
  schemaLookupDTO: SchemaLookupDTO,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<SchemaMap>(
    {
      url: `/api/workflow-builder/lookup/output-schema`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: schemaLookupDTO,
      signal,
    },
    options,
  );
};

export const getLookupOutputSchemaQueryKey = (
  schemaLookupDTO?: SchemaLookupDTO,
) => {
  return [
    `/api/workflow-builder/lookup/output-schema`,
    schemaLookupDTO,
  ] as const;
};

export const getLookupOutputSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupOutputSchemaQueryKey(schemaLookupDTO);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupOutputSchema>>
  > = ({ signal, meta }) =>
    lookupOutputSchema(schemaLookupDTO, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupOutputSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupOutputSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupOutputSchema>>
>;
export type LookupOutputSchemaQueryError = ErrorType<unknown>;

export function useLookupOutputSchema<
  TData = Awaited<ReturnType<typeof lookupOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupOutputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupOutputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupOutputSchema<
  TData = Awaited<ReturnType<typeof lookupOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupOutputSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupOutputSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupOutputSchema<
  TData = Awaited<ReturnType<typeof lookupOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Output Schema
 */

export function useLookupOutputSchema<
  TData = Awaited<ReturnType<typeof lookupOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupOutputSchemaQueryOptions(
    schemaLookupDTO,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Output Schema
 */
export const prefetchLookupOutputSchema = async <
  TData = Awaited<ReturnType<typeof lookupOutputSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupOutputSchemaQueryOptions(
    schemaLookupDTO,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Output Schema With Errors
 */
export const lookupOutputSchemaWithErrors = (
  schemaLookupDTO: SchemaLookupDTO,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeSchemaWithErrorsResponse>(
    {
      url: `/api/workflow-builder/lookup/output-schema/with-errors`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: schemaLookupDTO,
      signal,
    },
    options,
  );
};

export const getLookupOutputSchemaWithErrorsQueryKey = (
  schemaLookupDTO?: SchemaLookupDTO,
) => {
  return [
    `/api/workflow-builder/lookup/output-schema/with-errors`,
    schemaLookupDTO,
  ] as const;
};

export const getLookupOutputSchemaWithErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLookupOutputSchemaWithErrorsQueryKey(schemaLookupDTO);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>
  > = ({ signal, meta }) =>
    lookupOutputSchemaWithErrors(
      schemaLookupDTO,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupOutputSchemaWithErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>
>;
export type LookupOutputSchemaWithErrorsQueryError = ErrorType<unknown>;

export function useLookupOutputSchemaWithErrors<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
          TError,
          Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupOutputSchemaWithErrors<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
          TError,
          Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupOutputSchemaWithErrors<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Output Schema With Errors
 */

export function useLookupOutputSchemaWithErrors<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
  TError = ErrorType<unknown>,
>(
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupOutputSchemaWithErrorsQueryOptions(
    schemaLookupDTO,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Output Schema With Errors
 */
export const prefetchLookupOutputSchemaWithErrors = async <
  TData = Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  schemaLookupDTO: SchemaLookupDTO,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaWithErrors>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupOutputSchemaWithErrorsQueryOptions(
    schemaLookupDTO,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Output Schema
 */
export const lookupOutputSchemaByWorkflowId = (
  workflowId: string,
  lookupOutputSchemaByWorkflowIdBody: string[],
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<SchemaMap>(
    {
      url: `/api/workflow-builder/lookup/output-schema/${encodeURIComponent(String(workflowId))}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupOutputSchemaByWorkflowIdBody,
      signal,
    },
    options,
  );
};

export const getLookupOutputSchemaByWorkflowIdQueryKey = (
  workflowId?: string,
  lookupOutputSchemaByWorkflowIdBody?: string[],
) => {
  return [
    `/api/workflow-builder/lookup/output-schema/${workflowId}`,
    lookupOutputSchemaByWorkflowIdBody,
  ] as const;
};

export const getLookupOutputSchemaByWorkflowIdQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  lookupOutputSchemaByWorkflowIdBody: string[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLookupOutputSchemaByWorkflowIdQueryKey(
      workflowId,
      lookupOutputSchemaByWorkflowIdBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>
  > = ({ signal, meta }) =>
    lookupOutputSchemaByWorkflowId(
      workflowId,
      lookupOutputSchemaByWorkflowIdBody,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupOutputSchemaByWorkflowIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>
>;
export type LookupOutputSchemaByWorkflowIdQueryError = ErrorType<unknown>;

export function useLookupOutputSchemaByWorkflowId<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  lookupOutputSchemaByWorkflowIdBody: string[],
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
          TError,
          Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupOutputSchemaByWorkflowId<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  lookupOutputSchemaByWorkflowIdBody: string[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
          TError,
          Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupOutputSchemaByWorkflowId<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  lookupOutputSchemaByWorkflowIdBody: string[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Output Schema
 */

export function useLookupOutputSchemaByWorkflowId<
  TData = Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  lookupOutputSchemaByWorkflowIdBody: string[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupOutputSchemaByWorkflowIdQueryOptions(
    workflowId,
    lookupOutputSchemaByWorkflowIdBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Output Schema
 */
export const prefetchLookupOutputSchemaByWorkflowId = async <
  TData = Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  workflowId: string,
  lookupOutputSchemaByWorkflowIdBody: string[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupOutputSchemaByWorkflowId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupOutputSchemaByWorkflowIdQueryOptions(
    workflowId,
    lookupOutputSchemaByWorkflowIdBody,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Resources
 */
export const lookupResources = (
  lookupResourcesBody: string[],
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilderResourceMap>(
    {
      url: `/api/workflow-builder/lookup/resources`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupResourcesBody,
      signal,
    },
    options,
  );
};

export const getLookupResourcesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupResources>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupResources>>,
  TError,
  { data: string[] },
  TContext
> => {
  const mutationKey = ["lookupResources"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupResources>>,
    { data: string[] }
  > = (props, context) => {
    const { data } = props ?? {};

    return lookupResources(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupResourcesMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupResources>>
>;
export type LookupResourcesMutationBody = string[];
export type LookupResourcesMutationError = ErrorType<unknown>;

/**
 * @summary Lookup Resources
 */
export const useLookupResources = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lookupResources>>,
      TError,
      { data: string[] },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof lookupResources>>,
  TError,
  { data: string[] },
  TContext
> => {
  const mutationOptions = getLookupResourcesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Lookup Run Variables Schema
 */
export const lookupRunVariablesSchema = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/lookup/run-variables-schema`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupRunVariablesSchemaQueryKey = () => {
  return [`/api/workflow-builder/lookup/run-variables-schema`] as const;
};

export const getLookupRunVariablesSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupRunVariablesSchemaQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupRunVariablesSchema>>
  > = ({ signal, meta }) =>
    lookupRunVariablesSchema({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupRunVariablesSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupRunVariablesSchema>>
>;
export type LookupRunVariablesSchemaQueryError = ErrorType<unknown>;

export function useLookupRunVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupRunVariablesSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupRunVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupRunVariablesSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupRunVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Run Variables Schema
 */

export function useLookupRunVariablesSchema<
  TData = Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupRunVariablesSchemaQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Run Variables Schema
 */
export const prefetchLookupRunVariablesSchema = async <
  TData = Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRunVariablesSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupRunVariablesSchemaQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Runtime Connections Schema
 */
export const lookupRuntimeConnectionsSchema = (
  workflowId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/lookup/runtime-connections-schema/${encodeURIComponent(String(workflowId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupRuntimeConnectionsSchemaQueryKey = (
  workflowId?: string,
) => {
  return [
    `/api/workflow-builder/lookup/runtime-connections-schema/${workflowId}`,
  ] as const;
};

export const getLookupRuntimeConnectionsSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLookupRuntimeConnectionsSchemaQueryKey(workflowId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>
  > = ({ signal, meta }) =>
    lookupRuntimeConnectionsSchema(
      workflowId,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupRuntimeConnectionsSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>
>;
export type LookupRuntimeConnectionsSchemaQueryError = ErrorType<unknown>;

export function useLookupRuntimeConnectionsSchema<
  TData = Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupRuntimeConnectionsSchema<
  TData = Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupRuntimeConnectionsSchema<
  TData = Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Runtime Connections Schema
 */

export function useLookupRuntimeConnectionsSchema<
  TData = Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupRuntimeConnectionsSchemaQueryOptions(
    workflowId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Runtime Connections Schema
 */
export const prefetchLookupRuntimeConnectionsSchema = async <
  TData = Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupRuntimeConnectionsSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupRuntimeConnectionsSchemaQueryOptions(
    workflowId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Start Inputs
 */
export const lookupStartInputs = (
  workflowId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<StringObjectMap2>(
    {
      url: `/api/workflow-builder/lookup/start-inputs/${encodeURIComponent(String(workflowId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupStartInputsQueryKey = (workflowId?: string) => {
  return [`/api/workflow-builder/lookup/start-inputs/${workflowId}`] as const;
};

export const getLookupStartInputsQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupStartInputs>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartInputs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupStartInputsQueryKey(workflowId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupStartInputs>>
  > = ({ signal, meta }) =>
    lookupStartInputs(workflowId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupStartInputs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupStartInputsQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupStartInputs>>
>;
export type LookupStartInputsQueryError = ErrorType<unknown>;

export function useLookupStartInputs<
  TData = Awaited<ReturnType<typeof lookupStartInputs>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartInputs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupStartInputs>>,
          TError,
          Awaited<ReturnType<typeof lookupStartInputs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupStartInputs<
  TData = Awaited<ReturnType<typeof lookupStartInputs>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartInputs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupStartInputs>>,
          TError,
          Awaited<ReturnType<typeof lookupStartInputs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupStartInputs<
  TData = Awaited<ReturnType<typeof lookupStartInputs>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartInputs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Start Inputs
 */

export function useLookupStartInputs<
  TData = Awaited<ReturnType<typeof lookupStartInputs>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartInputs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupStartInputsQueryOptions(workflowId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Start Inputs
 */
export const prefetchLookupStartInputs = async <
  TData = Awaited<ReturnType<typeof lookupStartInputs>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartInputs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupStartInputsQueryOptions(workflowId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Start Input Resource
 */
export const lookupStartNodeResource = (
  workflowId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilderResource>(
    {
      url: `/api/workflow-builder/lookup/start-node-resource/${encodeURIComponent(String(workflowId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupStartNodeResourceQueryKey = (workflowId?: string) => {
  return [
    `/api/workflow-builder/lookup/start-node-resource/${workflowId}`,
  ] as const;
};

export const getLookupStartNodeResourceQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupStartNodeResource>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartNodeResource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupStartNodeResourceQueryKey(workflowId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupStartNodeResource>>
  > = ({ signal, meta }) =>
    lookupStartNodeResource(workflowId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupStartNodeResource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupStartNodeResourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupStartNodeResource>>
>;
export type LookupStartNodeResourceQueryError = ErrorType<unknown>;

export function useLookupStartNodeResource<
  TData = Awaited<ReturnType<typeof lookupStartNodeResource>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartNodeResource>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupStartNodeResource>>,
          TError,
          Awaited<ReturnType<typeof lookupStartNodeResource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupStartNodeResource<
  TData = Awaited<ReturnType<typeof lookupStartNodeResource>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartNodeResource>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupStartNodeResource>>,
          TError,
          Awaited<ReturnType<typeof lookupStartNodeResource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupStartNodeResource<
  TData = Awaited<ReturnType<typeof lookupStartNodeResource>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartNodeResource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Start Input Resource
 */

export function useLookupStartNodeResource<
  TData = Awaited<ReturnType<typeof lookupStartNodeResource>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartNodeResource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupStartNodeResourceQueryOptions(
    workflowId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Start Input Resource
 */
export const prefetchLookupStartNodeResource = async <
  TData = Awaited<ReturnType<typeof lookupStartNodeResource>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartNodeResource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupStartNodeResourceQueryOptions(
    workflowId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup Output Schema
 */
export const lookupStartSchema = (
  workflowId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/lookup/start-schema/${encodeURIComponent(String(workflowId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupStartSchemaQueryKey = (workflowId?: string) => {
  return [`/api/workflow-builder/lookup/start-schema/${workflowId}`] as const;
};

export const getLookupStartSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupStartSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupStartSchemaQueryKey(workflowId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupStartSchema>>
  > = ({ signal, meta }) =>
    lookupStartSchema(workflowId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupStartSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupStartSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupStartSchema>>
>;
export type LookupStartSchemaQueryError = ErrorType<unknown>;

export function useLookupStartSchema<
  TData = Awaited<ReturnType<typeof lookupStartSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupStartSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupStartSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupStartSchema<
  TData = Awaited<ReturnType<typeof lookupStartSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupStartSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupStartSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupStartSchema<
  TData = Awaited<ReturnType<typeof lookupStartSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup Output Schema
 */

export function useLookupStartSchema<
  TData = Awaited<ReturnType<typeof lookupStartSchema>>,
  TError = ErrorType<unknown>,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupStartSchemaQueryOptions(workflowId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup Output Schema
 */
export const prefetchLookupStartSchema = async <
  TData = Awaited<ReturnType<typeof lookupStartSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupStartSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupStartSchemaQueryOptions(workflowId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup User Variable Schema
 */
export const lookupUserVariableSchema = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/lookup/user-variables-schema`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getLookupUserVariableSchemaQueryKey = () => {
  return [`/api/workflow-builder/lookup/user-variables-schema`] as const;
};

export const getLookupUserVariableSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupUserVariableSchema>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof lookupUserVariableSchema>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupUserVariableSchemaQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupUserVariableSchema>>
  > = ({ signal, meta }) =>
    lookupUserVariableSchema({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupUserVariableSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupUserVariableSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupUserVariableSchema>>
>;
export type LookupUserVariableSchemaQueryError = ErrorType<unknown>;

export function useLookupUserVariableSchema<
  TData = Awaited<ReturnType<typeof lookupUserVariableSchema>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupUserVariableSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupUserVariableSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupUserVariableSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupUserVariableSchema<
  TData = Awaited<ReturnType<typeof lookupUserVariableSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupUserVariableSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupUserVariableSchema>>,
          TError,
          Awaited<ReturnType<typeof lookupUserVariableSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupUserVariableSchema<
  TData = Awaited<ReturnType<typeof lookupUserVariableSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupUserVariableSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup User Variable Schema
 */

export function useLookupUserVariableSchema<
  TData = Awaited<ReturnType<typeof lookupUserVariableSchema>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupUserVariableSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupUserVariableSchemaQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup User Variable Schema
 */
export const prefetchLookupUserVariableSchema = async <
  TData = Awaited<ReturnType<typeof lookupUserVariableSchema>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupUserVariableSchema>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupUserVariableSchemaQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Automap Node
 */
export const automapNode = (
  nodeAutoMapRequest: NodeAutoMapRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeAutoMapResponse>(
    {
      url: `/api/workflow-builder/node/automap`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nodeAutoMapRequest,
      signal,
    },
    options,
  );
};

export const getAutomapNodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automapNode>>,
    TError,
    { data: NodeAutoMapRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automapNode>>,
  TError,
  { data: NodeAutoMapRequest },
  TContext
> => {
  const mutationKey = ["automapNode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automapNode>>,
    { data: NodeAutoMapRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return automapNode(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomapNodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof automapNode>>
>;
export type AutomapNodeMutationBody = NodeAutoMapRequest;
export type AutomapNodeMutationError = ErrorType<unknown>;

/**
 * @summary Automap Node
 */
export const useAutomapNode = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automapNode>>,
      TError,
      { data: NodeAutoMapRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automapNode>>,
  TError,
  { data: NodeAutoMapRequest },
  TContext
> => {
  const mutationOptions = getAutomapNodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Is Node Resource Entity Search Enabled
 */
export const isNodeResourceEntitySearchEnabled = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/workflow-builder/node/resource/entity-search-enabled`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getIsNodeResourceEntitySearchEnabledQueryKey = () => {
  return [`/api/workflow-builder/node/resource/entity-search-enabled`] as const;
};

export const getIsNodeResourceEntitySearchEnabledQueryOptions = <
  TData = Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getIsNodeResourceEntitySearchEnabledQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>
  > = ({ signal, meta }) =>
    isNodeResourceEntitySearchEnabled({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsNodeResourceEntitySearchEnabledQueryResult = NonNullable<
  Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>
>;
export type IsNodeResourceEntitySearchEnabledQueryError = ErrorType<unknown>;

export function useIsNodeResourceEntitySearchEnabled<
  TData = Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
          TError,
          Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIsNodeResourceEntitySearchEnabled<
  TData = Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
          TError,
          Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIsNodeResourceEntitySearchEnabled<
  TData = Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Is Node Resource Entity Search Enabled
 */

export function useIsNodeResourceEntitySearchEnabled<
  TData = Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getIsNodeResourceEntitySearchEnabledQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Is Node Resource Entity Search Enabled
 */
export const prefetchIsNodeResourceEntitySearchEnabled = async <
  TData = Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isNodeResourceEntitySearchEnabled>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getIsNodeResourceEntitySearchEnabledQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Resources For Node Builders
 */
export const findResourcesForNodes = (
  findNodeBuilderResourcesRequest: FindNodeBuilderResourcesRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilderResourceListMap>(
    {
      url: `/api/workflow-builder/node/resources`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: findNodeBuilderResourcesRequest,
      signal,
    },
    options,
  );
};

export const getFindResourcesForNodesQueryKey = (
  findNodeBuilderResourcesRequest?: FindNodeBuilderResourcesRequest,
) => {
  return [
    `/api/workflow-builder/node/resources`,
    findNodeBuilderResourcesRequest,
  ] as const;
};

export const getFindResourcesForNodesQueryOptions = <
  TData = Awaited<ReturnType<typeof findResourcesForNodes>>,
  TError = ErrorType<unknown>,
>(
  findNodeBuilderResourcesRequest: FindNodeBuilderResourcesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFindResourcesForNodesQueryKey(findNodeBuilderResourcesRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findResourcesForNodes>>
  > = ({ signal, meta }) =>
    findResourcesForNodes(
      findNodeBuilderResourcesRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findResourcesForNodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindResourcesForNodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof findResourcesForNodes>>
>;
export type FindResourcesForNodesQueryError = ErrorType<unknown>;

export function useFindResourcesForNodes<
  TData = Awaited<ReturnType<typeof findResourcesForNodes>>,
  TError = ErrorType<unknown>,
>(
  findNodeBuilderResourcesRequest: FindNodeBuilderResourcesRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNodes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findResourcesForNodes>>,
          TError,
          Awaited<ReturnType<typeof findResourcesForNodes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindResourcesForNodes<
  TData = Awaited<ReturnType<typeof findResourcesForNodes>>,
  TError = ErrorType<unknown>,
>(
  findNodeBuilderResourcesRequest: FindNodeBuilderResourcesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNodes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findResourcesForNodes>>,
          TError,
          Awaited<ReturnType<typeof findResourcesForNodes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindResourcesForNodes<
  TData = Awaited<ReturnType<typeof findResourcesForNodes>>,
  TError = ErrorType<unknown>,
>(
  findNodeBuilderResourcesRequest: FindNodeBuilderResourcesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Resources For Node Builders
 */

export function useFindResourcesForNodes<
  TData = Awaited<ReturnType<typeof findResourcesForNodes>>,
  TError = ErrorType<unknown>,
>(
  findNodeBuilderResourcesRequest: FindNodeBuilderResourcesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindResourcesForNodesQueryOptions(
    findNodeBuilderResourcesRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Resources For Node Builders
 */
export const prefetchFindResourcesForNodes = async <
  TData = Awaited<ReturnType<typeof findResourcesForNodes>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  findNodeBuilderResourcesRequest: FindNodeBuilderResourcesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindResourcesForNodesQueryOptions(
    findNodeBuilderResourcesRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Node Suggestions
 */
export const findNodeSuggestions = (
  nodeAutoMapRequest: NodeAutoMapRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Schema>(
    {
      url: `/api/workflow-builder/node/suggestions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nodeAutoMapRequest,
      signal,
    },
    options,
  );
};

export const getFindNodeSuggestionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findNodeSuggestions>>,
    TError,
    { data: NodeAutoMapRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof findNodeSuggestions>>,
  TError,
  { data: NodeAutoMapRequest },
  TContext
> => {
  const mutationKey = ["findNodeSuggestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof findNodeSuggestions>>,
    { data: NodeAutoMapRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return findNodeSuggestions(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type FindNodeSuggestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof findNodeSuggestions>>
>;
export type FindNodeSuggestionsMutationBody = NodeAutoMapRequest;
export type FindNodeSuggestionsMutationError = ErrorType<unknown>;

/**
 * @summary Find Node Suggestions
 */
export const useFindNodeSuggestions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof findNodeSuggestions>>,
      TError,
      { data: NodeAutoMapRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof findNodeSuggestions>>,
  TError,
  { data: NodeAutoMapRequest },
  TContext
> => {
  const mutationOptions = getFindNodeSuggestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Id
 */
export const getNode = (
  name: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilder>(
    {
      url: `/api/workflow-builder/node/${encodeURIComponent(String(name))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetNodeQueryKey = (name?: string) => {
  return [`/api/workflow-builder/node/${name}`] as const;
};

export const getGetNodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNodeQueryKey(name);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNode>>> = ({
    signal,
    meta,
  }) => getNode(name, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetNodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNode>>
>;
export type GetNodeQueryError = ErrorType<unknown>;

export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNode>>,
          TError,
          Awaited<ReturnType<typeof getNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNode>>,
          TError,
          Awaited<ReturnType<typeof getNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNodeQueryOptions(name, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find By Id
 */
export const prefetchGetNode = async <
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetNodeQueryOptions(name, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Resources For Node Builder
 */
export const findResourcesForNode = (
  name: string,
  params?: FindResourcesForNodeParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilderResourceHits>(
    {
      url: `/api/workflow-builder/node/${encodeURIComponent(String(name))}/resources`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getFindResourcesForNodeQueryKey = (
  name?: string,
  params?: FindResourcesForNodeParams,
) => {
  return [
    `/api/workflow-builder/node/${name}/resources`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindResourcesForNodeQueryOptions = <
  TData = Awaited<ReturnType<typeof findResourcesForNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  params?: FindResourcesForNodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindResourcesForNodeQueryKey(name, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findResourcesForNode>>
  > = ({ signal, meta }) =>
    findResourcesForNode(name, params, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    staleTime: Infinity,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findResourcesForNode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindResourcesForNodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof findResourcesForNode>>
>;
export type FindResourcesForNodeQueryError = ErrorType<unknown>;

export function useFindResourcesForNode<
  TData = Awaited<ReturnType<typeof findResourcesForNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  params: undefined | FindResourcesForNodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findResourcesForNode>>,
          TError,
          Awaited<ReturnType<typeof findResourcesForNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindResourcesForNode<
  TData = Awaited<ReturnType<typeof findResourcesForNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  params?: FindResourcesForNodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findResourcesForNode>>,
          TError,
          Awaited<ReturnType<typeof findResourcesForNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindResourcesForNode<
  TData = Awaited<ReturnType<typeof findResourcesForNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  params?: FindResourcesForNodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Resources For Node Builder
 */

export function useFindResourcesForNode<
  TData = Awaited<ReturnType<typeof findResourcesForNode>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  params?: FindResourcesForNodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindResourcesForNodeQueryOptions(
    name,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Resources For Node Builder
 */
export const prefetchFindResourcesForNode = async <
  TData = Awaited<ReturnType<typeof findResourcesForNode>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  name: string,
  params?: FindResourcesForNodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourcesForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindResourcesForNodeQueryOptions(
    name,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Resource For Node Builder
 */
export const findResourceForNode = (
  nodeName: string,
  resourceName: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilderResource>(
    {
      url: `/api/workflow-builder/node/${encodeURIComponent(String(nodeName))}/resource/${encodeURIComponent(String(resourceName))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getFindResourceForNodeQueryKey = (
  nodeName?: string,
  resourceName?: string,
) => {
  return [
    `/api/workflow-builder/node/${nodeName}/resource/${resourceName}`,
  ] as const;
};

export const getFindResourceForNodeQueryOptions = <
  TData = Awaited<ReturnType<typeof findResourceForNode>>,
  TError = ErrorType<unknown>,
>(
  nodeName: string,
  resourceName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourceForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFindResourceForNodeQueryKey(nodeName, resourceName);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findResourceForNode>>
  > = ({ signal, meta }) =>
    findResourceForNode(
      nodeName,
      resourceName,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(nodeName && resourceName),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findResourceForNode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindResourceForNodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof findResourceForNode>>
>;
export type FindResourceForNodeQueryError = ErrorType<unknown>;

export function useFindResourceForNode<
  TData = Awaited<ReturnType<typeof findResourceForNode>>,
  TError = ErrorType<unknown>,
>(
  nodeName: string,
  resourceName: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourceForNode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findResourceForNode>>,
          TError,
          Awaited<ReturnType<typeof findResourceForNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindResourceForNode<
  TData = Awaited<ReturnType<typeof findResourceForNode>>,
  TError = ErrorType<unknown>,
>(
  nodeName: string,
  resourceName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourceForNode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findResourceForNode>>,
          TError,
          Awaited<ReturnType<typeof findResourceForNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindResourceForNode<
  TData = Awaited<ReturnType<typeof findResourceForNode>>,
  TError = ErrorType<unknown>,
>(
  nodeName: string,
  resourceName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourceForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Resource For Node Builder
 */

export function useFindResourceForNode<
  TData = Awaited<ReturnType<typeof findResourceForNode>>,
  TError = ErrorType<unknown>,
>(
  nodeName: string,
  resourceName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourceForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindResourceForNodeQueryOptions(
    nodeName,
    resourceName,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Resource For Node Builder
 */
export const prefetchFindResourceForNode = async <
  TData = Awaited<ReturnType<typeof findResourceForNode>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  nodeName: string,
  resourceName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findResourceForNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindResourceForNodeQueryOptions(
    nodeName,
    resourceName,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Nodes
 */
export const getNodes = (
  params?: GetNodesParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodeBuilderHits>(
    { url: `/api/workflow-builder/nodes`, method: "GET", params, signal },
    options,
  );
};

export const getGetNodesQueryKey = (params?: GetNodesParams) => {
  return [`/api/workflow-builder/nodes`, ...(params ? [params] : [])] as const;
};

export const getGetNodesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNodes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNodes>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNodesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodes>>> = ({
    signal,
    meta,
  }) => getNodes(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNodes>>
>;
export type GetNodesQueryError = ErrorType<unknown>;

export function useGetNodes<
  TData = Awaited<ReturnType<typeof getNodes>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetNodesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNodes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNodes>>,
          TError,
          Awaited<ReturnType<typeof getNodes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNodes<
  TData = Awaited<ReturnType<typeof getNodes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNodes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNodes>>,
          TError,
          Awaited<ReturnType<typeof getNodes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNodes<
  TData = Awaited<ReturnType<typeof getNodes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNodes>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Nodes
 */

export function useGetNodes<
  TData = Awaited<ReturnType<typeof getNodes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNodes>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNodesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Nodes
 */
export const prefetchGetNodes = async <
  TData = Awaited<ReturnType<typeof getNodes>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: GetNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNodes>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetNodesQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Nodes And Resources
 */
export const searchNodesAndResources = (
  nodeSearchQuery: NodeSearchQuery,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NodesAndResourcesSearchResponse>(
    {
      url: `/api/workflow-builder/search-nodes-and-resources`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nodeSearchQuery,
      signal,
    },
    options,
  );
};

export const getSearchNodesAndResourcesInfiniteQueryKey = (
  nodeSearchQuery?: NodeSearchQuery,
) => {
  return [
    "infinite",
    `/api/workflow-builder/search-nodes-and-resources`,
    nodeSearchQuery,
  ] as const;
};

export const getSearchNodesAndResourcesQueryKey = (
  nodeSearchQuery?: NodeSearchQuery,
) => {
  return [
    `/api/workflow-builder/search-nodes-and-resources`,
    nodeSearchQuery,
  ] as const;
};

export const getSearchNodesAndResourcesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof searchNodesAndResources>>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchNodesAndResourcesInfiniteQueryKey(nodeSearchQuery);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchNodesAndResources>>
  > = ({ signal, meta }) =>
    searchNodesAndResources(
      nodeSearchQuery,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof searchNodesAndResources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchNodesAndResourcesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchNodesAndResources>>
>;
export type SearchNodesAndResourcesInfiniteQueryError = ErrorType<unknown>;

export function useSearchNodesAndResourcesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof searchNodesAndResources>>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNodesAndResources>>,
          TError,
          Awaited<ReturnType<typeof searchNodesAndResources>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchNodesAndResourcesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof searchNodesAndResources>>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNodesAndResources>>,
          TError,
          Awaited<ReturnType<typeof searchNodesAndResources>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchNodesAndResourcesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof searchNodesAndResources>>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Nodes And Resources
 */

export function useSearchNodesAndResourcesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof searchNodesAndResources>>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchNodesAndResourcesInfiniteQueryOptions(
    nodeSearchQuery,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Nodes And Resources
 */
export const prefetchSearchNodesAndResourcesInfinite = async <
  TData = Awaited<ReturnType<typeof searchNodesAndResources>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchNodesAndResourcesInfiniteQueryOptions(
    nodeSearchQuery,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getSearchNodesAndResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchNodesAndResources>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchNodesAndResourcesQueryKey(nodeSearchQuery);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchNodesAndResources>>
  > = ({ signal, meta }) =>
    searchNodesAndResources(
      nodeSearchQuery,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchNodesAndResources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchNodesAndResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchNodesAndResources>>
>;
export type SearchNodesAndResourcesQueryError = ErrorType<unknown>;

export function useSearchNodesAndResources<
  TData = Awaited<ReturnType<typeof searchNodesAndResources>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNodesAndResources>>,
          TError,
          Awaited<ReturnType<typeof searchNodesAndResources>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchNodesAndResources<
  TData = Awaited<ReturnType<typeof searchNodesAndResources>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNodesAndResources>>,
          TError,
          Awaited<ReturnType<typeof searchNodesAndResources>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchNodesAndResources<
  TData = Awaited<ReturnType<typeof searchNodesAndResources>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Nodes And Resources
 */

export function useSearchNodesAndResources<
  TData = Awaited<ReturnType<typeof searchNodesAndResources>>,
  TError = ErrorType<unknown>,
>(
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchNodesAndResourcesQueryOptions(
    nodeSearchQuery,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Nodes And Resources
 */
export const prefetchSearchNodesAndResources = async <
  TData = Awaited<ReturnType<typeof searchNodesAndResources>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  nodeSearchQuery: NodeSearchQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNodesAndResources>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchNodesAndResourcesQueryOptions(
    nodeSearchQuery,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Webhook Trigger Url
 */
export const getWebhookTriggerUrl = (
  params?: GetWebhookTriggerUrlParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<StringObjectMap2>(
    {
      url: `/api/workflow-builder/webhook-trigger-url`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetWebhookTriggerUrlQueryKey = (
  params?: GetWebhookTriggerUrlParams,
) => {
  return [
    `/api/workflow-builder/webhook-trigger-url`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWebhookTriggerUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookTriggerUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWebhookTriggerUrlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWebhookTriggerUrl>>
  > = ({ signal, meta }) =>
    getWebhookTriggerUrl(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWebhookTriggerUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookTriggerUrl>>
>;
export type GetWebhookTriggerUrlQueryError = ErrorType<unknown>;

export function useGetWebhookTriggerUrl<
  TData = Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetWebhookTriggerUrlParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
          TError,
          Awaited<ReturnType<typeof getWebhookTriggerUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWebhookTriggerUrl<
  TData = Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookTriggerUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
          TError,
          Awaited<ReturnType<typeof getWebhookTriggerUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWebhookTriggerUrl<
  TData = Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookTriggerUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Webhook Trigger Url
 */

export function useGetWebhookTriggerUrl<
  TData = Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookTriggerUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWebhookTriggerUrlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Webhook Trigger Url
 */
export const prefetchGetWebhookTriggerUrl = async <
  TData = Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: GetWebhookTriggerUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookTriggerUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetWebhookTriggerUrlQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Webhook Url
 */
export const getWebhookUrl = (
  params?: GetWebhookUrlParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<StringObjectMap2>(
    { url: `/api/workflow-builder/webhook-url`, method: "GET", params, signal },
    options,
  );
};

export const getGetWebhookUrlQueryKey = (params?: GetWebhookUrlParams) => {
  return [
    `/api/workflow-builder/webhook-url`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWebhookUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookUrlQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebhookUrl>>> = ({
    signal,
    meta,
  }) => getWebhookUrl(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWebhookUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookUrl>>
>;
export type GetWebhookUrlQueryError = ErrorType<unknown>;

export function useGetWebhookUrl<
  TData = Awaited<ReturnType<typeof getWebhookUrl>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetWebhookUrlParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookUrl>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookUrl>>,
          TError,
          Awaited<ReturnType<typeof getWebhookUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWebhookUrl<
  TData = Awaited<ReturnType<typeof getWebhookUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookUrl>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookUrl>>,
          TError,
          Awaited<ReturnType<typeof getWebhookUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWebhookUrl<
  TData = Awaited<ReturnType<typeof getWebhookUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Webhook Url
 */

export function useGetWebhookUrl<
  TData = Awaited<ReturnType<typeof getWebhookUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWebhookUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWebhookUrlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Webhook Url
 */
export const prefetchGetWebhookUrl = async <
  TData = Awaited<ReturnType<typeof getWebhookUrl>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: GetWebhookUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetWebhookUrlQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
